<ham-modal [size]="'sm'" (cancel)="closeDialog()" [hideFooter]="true" [title]="'invite_friend_modal_title' | i18next">
    <div class="flex-center">
        <span class="text1">{{ 'invite_friend_description' | i18next }}</span>
        <input
            class="email-input"
            hamInput
            #emailInput
            [label]="'invite_friend_email_label' | i18next"
            [formControl]="emailControl"
            [placeholder]="'name@example.com'"
            [ngStyle]="{ width: '552px' }"
            (keydown)="onEmailKeyDown($event)"
        />
        <div>
            <mat-chip-list #chipList>
                <mat-chip
                    *ngFor="let email of emailChips"
                    [selectable]="true"
                    [removable]="true"
                    (removed)="removeChip(email)"
                >
                    {{ email }}
                    <mat-icon matChipRemove>clear</mat-icon>
                </mat-chip>
            </mat-chip-list>
        </div>
        <textarea
            hamInput
            #messageInput
            [label]="'invite_friend_message_label' | i18next"
            [formControl]="message"
            [placeholder]="'invite_friend_message_placeholder' | i18next"
            [ngStyle]="{ width: '552px', height: '200px', resize: 'vertical' }"
        ></textarea>

        <div class="action-buttons">
            <span>
                <ham-button
                    class="workflow-cancel-button"
                    size="sm"
                    (buttonClick)="closeDialog()"
                    type="submit"
                    variant="transparent"
                    outline="true"
                >
                    {{ 'aumico_button_cancel' | i18next }}
                </ham-button>
            </span>
            <span>
                <ham-button
                    class="workflow-confirm-button"
                    size="sm"
                    (buttonClick)="onSaveAndInviteClick()"
                    [disabled]="(!emailControl.valid && emailChips.length === 0) || !message.valid"
                    type="submit"
                >
                    {{ 'aumico_button_submit' | i18next }}
                </ham-button>
            </span>
        </div>
    </div>
</ham-modal>
